import React, { createContext, useState, useContext, FC } from 'react';

const defaultModalConfig = {
  content: null,
  onConfirm: () => {},
  title: '',
};

interface ModalHeaderType {
  right?: JSX.Element | null;
}

const ModalContext = createContext<any>({
  isModalOpen: false,
  showModal: (content: any) => {},
  hideModal: () => {},
  modalContent: defaultModalConfig,
  modalHeader: null,
});

export function useModal() {
  return useContext(ModalContext);
}

export function ModalProvider({ children }: any) {
  const [modalContent, setModalContent] = useState(defaultModalConfig);
  const [modalHeader, setModalHeader] = useState<ModalHeaderType | null>({
    right: <></>,
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = (config: any) => {
    setModalContent(config);
    setIsModalOpen(true);
  };

  const hideModal = () => {
    setIsModalOpen(false);
    setModalContent(defaultModalConfig);
  };

  return (
    <ModalContext.Provider
      value={{
        isModalOpen,
        showModal,
        hideModal,
        modalContent,
        modalHeader,
        setModalHeader,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}
